enum GlobalSettingsEvents {
  OPEN_GLOBAL_SETTINGS = 'open-global-settings',
  GLOBAL_SETTINGS_CLOSED = 'global-settings-closed',
}
export default GlobalSettingsEvents
